export const actionTypes = {
  REMOVE_TOAST: "REMOVE_TOAST",
  GET_COMPANIES: "GET_COMPANIES",
  GET_COMPANIES_SUCCESS: "GET_COMPANIES_SUCCESS",
  GET_COMPANIES_FAILED: "GET_COMPANIES_FAILED",
  GET_ALL_COMPANIES: "GET_ALL_COMPANIES",
  GET_ALL_COMPANIES_SUCCESS: "GET_ALL_COMPANIES_SUCCESS",
  GET_ALL_COMPANIES_FAILED: "GET_ALL_COMPANIES_FAILED",
  CREATE_COMPANY: "CREATE_COMPANY",
  CREATE_COMPANY_SUCCESS: "CREATE_COMPANY_SUCCESS",
  CREATE_COMPANY_FAILED: "CREATE_COMPANY_FAILED",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  UPDATE_COMPANY_SUCCESS: "UPDATE_COMPANY_SUCCESS",
  UPDATE_COMPANY_FAILED: "UPDATE_COMPANY_FAILED",
  DELETE_COMPANY: "DELETE_COMPANY",
  DELETE_COMPANY_SUCCESS: "DELETE_COMPANY_SUCCESS",
  DELETE_COMPANY_FAILED: "DELETE_COMPANY_FAILED",
  GET_COMPANY_DETAILS: "GET_COMPANY_DETAILS",
  GET_COMPANY_DETAILS_SUCCESS: "GET_COMPANY_DETAILS_SUCCESS",
  GET_COMPANY_DETAILS_FAILED: "GET_COMPANY_DETAILS_FAILED"
}

const initialState = {
  data: null,
  data_all: null,
  link: null,
  meta: null,
  isLoading: false,
  toast: null,
  errors: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_TOAST:
      return Object.assign({}, state, { toast: null });
    case actionTypes.GET_COMPANIES:
    case actionTypes.CREATE_COMPANY:
    case actionTypes.UPDATE_COMPANY:
    case actionTypes.DELETE_COMPANY:
    case actionTypes.GET_COMPANY_DETAILS:
      return Object.assign({}, state, { isLoading: true, errors: null });
    case actionTypes.GET_COMPANIES_FAILED:
    case actionTypes.CREATE_COMPANY_FAILED:
    case actionTypes.UPDATE_COMPANY_FAILED:
    case actionTypes.DELETE_COMPANY_FAILED:
    case actionTypes.GET_COMPANY_DETAILS_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        toast: { type: "failed", message: action.payload.error }
      });
    case actionTypes.GET_COMPANIES_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload.data,
        meta: action.payload.meta,
        link: action.payload.link,
        isLoading: false,
        errors: null,
      });
    case actionTypes.GET_ALL_COMPANIES_SUCCESS:
      return Object.assign({}, state, {
        data_all: action.payload.data,
        isLoading: false,
        errors: null,
      });
    case actionTypes.CREATE_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: { type: "success", message: "Data successfully created", request: "add" }
      });
    case actionTypes.UPDATE_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: { type: "success", message: "Update successful", request: "edit" }
      });
    case actionTypes.DELETE_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: { type: "success", message: "Delete successful" }
      });
    case actionTypes.GET_COMPANY_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        company_details: action.payload.data,
        isLoading: false,
        error: false,
      })
    default:
      return state;
  }
}

export const actionCreators = {
  removeToast: () => ({ type: actionTypes.REMOVE_TOAST }),
  getCompany: (id, params) => ({
    type: actionTypes.GET_COMPANIES,
    id,
    params
  }),
  createCompany: (id, body) => ({
    type: actionTypes.CREATE_COMPANY,
    id,
    body
  }),
  updateCompany: (customer_id, company_id, body) => ({
    type: actionTypes.UPDATE_COMPANY,
    customer_id,
    company_id,
    body
  }),
  deleteCompany: (customer_id, company_id) => ({
    type: actionTypes.DELETE_COMPANY,
    customer_id,
    company_id,
  }),
  getCompanyDetails: (customer_id, company_id) => ({
    type: actionTypes.GET_COMPANY_DETAILS,
    customer_id,
    company_id
  })
}


// WEBPACK FOOTER //
// ./src/modules/company/pages/company/reducer.js